export const ACCOUNT_STATEMENT = "ACCOUNT_STATEMENT";
export const WITHDRAW_LIST = "WITHDRAW_LIST";
export const DEPOSIT_LIST = "DEPOSIT_LIST";
export const ALL_GATEWAYS = "ALL_GATEWAYS";
export const SELECTED_GATEWAY = "SELECTED_GATEWAY";
